import { Button, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ReactNode, useState } from "react";
import { IconType } from "./TableIndex";
import { useDispatch } from "react-redux";

export interface MenuItemType {
  label?: string;
  Label?: ReactNode;
  content?: (item?: any) => ReactNode;
  onClick?: () => void;
  icon?: ReactNode;
  Icon?: IconType;
  show?: boolean;
}

export interface TableMenuProps {
  items: MenuItemType[];
  actions: any;
  item: any;
  isEditable?: boolean;
}

export default function TableMenu(props: TableMenuProps) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (props.actions.openDrawer) return props.actions.openDrawer(dispatch, props.item);
    else setAnchorEl(event.currentTarget);
  };
  const handleClose = (item: MenuItemType) => {
    setAnchorEl(null);
    item.onClick && item.onClick();
  };
  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        style={{ backgroundColor: "transparent" }}
      >
        <MoreVertIcon
          style={{
            color: `${!open ? "#8f8f8f" : ""}`,
            transform: `${open ? "rotate(90deg)" : ""}`,
            transition: "300ms",
          }}
        />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ left: "20px" }}
        style={{ borderRadius: "4px" }}
        disableScrollLock
        MenuListProps={{ style: { padding: 0 } }}
      >
        {props.items.map((item, index) => {
          const { Icon, icon, label, Label, show, content } = item;
          // if (item.label === "ویرایش" && !props.isEditable) return <></>;
          if (!show) return <></>;
          return (
            <MenuItem
              key={index}
              onClick={() => handleClose(item)}
              style={{
                direction: "rtl",
                display: "flex",
                gap: "10px",
                alignItems: "center",
                borderBottom: index === props.items.length - 1 ? "" : "0.5px solid #E1EAF5",
                padding: "12px",
              }}
            >
              {icon && <span>{icon}</span>}
              {Icon && (
                <span>
                  <Icon style={{ color: "#31363D" }} />
                </span>
              )}
              {label && <span style={{ color: "#444", fontSize: "12px", fontWeight: 400 }}>{label}</span>}
              {Label}
              {content && content(props.item)}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
